var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle (4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.6746 6.49353L10.0021 8.82096L12.3294 6.49353L13.508 7.67205L11.1806 9.99946L13.508 12.3269L12.3294 13.5054L10.0021 11.178L7.6746 13.5054L6.49609 12.3269L8.82347 9.99946L6.49609 7.67205L7.6746 6.49353Z",
    fill: "#6D0F14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3347 9.99947C18.3347 14.6018 14.6037 18.3328 10.0013 18.3328C5.39894 18.3328 1.66797 14.6018 1.66797 9.99947C1.66797 5.3971 5.39894 1.66614 10.0013 1.66614C14.6037 1.66614 18.3347 5.3971 18.3347 9.99947ZM16.668 9.99947C16.668 13.6814 13.6832 16.6661 10.0013 16.6661C6.31941 16.6661 3.33464 13.6814 3.33464 9.99947C3.33464 6.31757 6.31941 3.3328 10.0013 3.3328C13.6832 3.3328 16.668 6.31757 16.668 9.99947Z",
    fill: "#6D0F14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleRed);
export default __webpack_public_path__ + "static/media/closeCircleRed.08318f647dd8494140c93ffa8b149e1f.svg";
export { ForwardRef as ReactComponent };